export const collection = {
    noData: 'You have not owned any NFT.',
    title: 'Your Collections',
};
